import i18n from '@risksmart-app/i18n/src/i18n';

import { wouldCreateCycleForContainers } from './conditionalLogicGraph';
import type { FieldEditorValues, SectionEditorValues } from './config';
import type { FieldSummary } from './constants';
import {
  buildRequiredFieldDropReason,
  findRequiredFieldsInConditionalSections,
} from './requiredFieldGuard';

// Resolved lazily — a module-level `i18n.t` runs before i18n is initialised and
// would return the raw key.
export const getCycleDropReason = (): string =>
  i18n.t('formEditorConditionalLogic.cycleRejection');

export type DropEvaluation =
  | { allowed: true }
  | { allowed: false; reason: string };

/** Takes the container map the move *would* produce, not the current one. */
export const evaluateDrop = ({
  containers,
  toContainerId,
  fields,
  fieldConfigs,
  sectionConfigs,
}: {
  /** The container map the move would produce, not the current one. */
  containers: Record<string, string[]>;
  toContainerId: string;
  fields: Record<string, FieldSummary>;
  fieldConfigs: Record<string, FieldEditorValues>;
  sectionConfigs: Record<string, SectionEditorValues>;
}): DropEvaluation => {
  if (
    wouldCreateCycleForContainers({ fieldConfigs, sectionConfigs, containers })
  ) {
    return { allowed: false, reason: getCycleDropReason() };
  }

  const violation = findRequiredFieldsInConditionalSections({
    containers,
    fields,
    sectionConfigs,
  }).find((v) => v.sectionId === toContainerId);

  if (violation) {
    return {
      allowed: false,
      reason: buildRequiredFieldDropReason(violation.fieldIds, fields),
    };
  }

  return { allowed: true };
};
